module.exports = __webpack_public_path__ + "static/media/Roose Bolton 1.f84fea50.jpg";